import { TFunction } from 'hooks/useI18n';
import { IntroDataProps } from './Intro.types';

export const INTRODATA = (
  t: TFunction,
  locale: string | undefined,
  manfreditesCount: number
): IntroDataProps[] => [
  {
    value: '112.600',
    text: t('mantechcar25.data.people')
  },
  {
    value: '+8.000',
    text: t('mantechcar25.data.current')
  },
  {
    value: '54%',
    text: t('mantechcar25.data.companies')
  },
  {
    value: '+850',
    text: t('mantechcar25.data.time-to-hire')
  }
];
